export var AUTH_ROUTES = {
    login: {
        id: 'login-page-id',
        route: 'login',
    },
    code_approve: {
        id: 'code_approve-id',
        route: 'code-approve',
    },
    company_registration: {
        id: 'company_registration-id',
        route: 'company-registration',
    },
};
